export default "__VITE_ASSET__7bbe23f5__"